var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle5A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35__2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35_a_7_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M477.9,191.2c-0.2-4.9-1.1-8.7-4.3-12.7c-0.5,6.6-4.7,13.5-8.6,16.5c2.2-17.3,2.2-51.1-14.7-67.9 c1.1,3.1,0.2,8.4-2.3,11.1c-0.7-3.3-1.8-6.5-3.3-9.7c-1.9-4-7.9-12-3.5-18.5c-6,0.4-9.2,5.3-10.9,11.1c-1.2-3.3-2.8-6.3-5-9 c-6.4-7.7-27.6-21.9-16.4-32.6c-12.4,4-21.2,10.8-27.3,19.1c-1.5-17-7.8-32.4-27.6-37.4c5.6,3.2,3.4,12,2.3,16.2 c-4,9.1-10,16.8-14.6,25c-0.9-1-1.9-2-2.8-2.9c-5.1-4.3-8.4-8.5-11.8-13.6c-0.9-1.6-1.6-3.2-2.2-4.9c-1-3.4-1.2-7.2-0.2-11.5 c-4.9,3.2-9.3,6.5-13,10.3c-1.2,1.3-2.4,2.6-3.4,3.9c-2.1,3-3.8,6.1-4.9,9.3c-1.2,3.2-1.9,6.5-2.3,9.8c-0.2,2.8-0.2,5.7-0.1,8.5 c-6.2-4.3-12.4-7.9-12.2-17.1c-10,5.4-20.2,14.8-24.2,25c-2.5,6.2-2.8,13-1.8,19.7c-4.1-3.3-7.7-6.4-9.9-10.1 c-8.6,6.9-14.6,26.2-6.4,38.1c-3.4-1.5-8.4-6-8.9-9.2c-6,13.3-4.6,26.7-3.7,41c0.7,10.4,9,25.4,14.9,34.3 c4.5,6.8,8.2,13.4,10.8,20.4c0-0.6,0-1,0-1.3c-0.2-7.4,0.6-14.5,0.7-21.9c0.3-21.4,7.3-41.6,22.9-53.8c1.1-0.9,2.3-1.7,3.5-2.5 c8.5-5.6,19.2-9,32.4-9.5c2-0.3,4-0.6,6-0.8c0.2,0,0.4,0,0.6-0.1c9.5-1.1,19-1.6,28.6-2.1c0.7,0,1.5-0.1,2.2-0.1 c1.5-0.1,3-0.1,4.5-0.2c3.4-0.2,6.7-0.4,10.2-0.5c1.8-0.1,3.7-0.2,5.6-0.3c7.6-0.3,15.3-0.5,22.8,0c8.2,0.5,14.9,2.4,20.9,5.8 c1.1,0.6,2.2,1.3,3.2,2.1c3.6,2.6,7,5.7,10.2,9.7c0.5,0.6,1,1.3,1.5,2s1,1.4,1.5,2.1c6.2,9.5,8.6,20.2,11.5,31.2 c2.8,10.7,5.8,24,8.2,37.1C462,231.9,478.7,212.1,477.9,191.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M276.7,102.6c-5.4,4.8-9.9,10.5-12.3,16.5c-4.5,11.3-1.9,24.5,2.7,35.5c2.2,5.2,9.4,17.3,16,21.8 c1.5-1.2,3.1-2.3,4.8-3.3C269.4,154.4,265.3,125.1,276.7,102.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M311.2,107.9c-1-12.9,3.1-25.8,12.8-34c0.1-1.5,0.3-3,0.7-4.6c-4.9,3.2-9.3,6.5-13,10.3 c-1.2,1.3-2.4,2.6-3.4,3.9c-2.1,3-3.8,6.1-4.9,9.3c-1.2,3.2-1.9,6.5-2.3,9.8c-1.1,16.9,2.3,34,13.3,48.2c2.2,3.1,4.6,6,7.3,8.8 c1.2,1.3,2.5,2.6,3.9,3.8c5-0.6,10-1,15-1.3c-1.3-1.3-2.5-2.7-3.7-4.1C323.6,144.1,313.4,127,311.2,107.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M348.5,124.7c0-1.9,0.2-3.9,0.4-5.8c0.3-6.6,3-12.3,6-17.8c0.8-1.4,1.5-2.7,2.3-4.1 c6.7-9.6,9.4-22.3,4.6-33.2c-2.3-1.1-4.9-2.1-7.8-2.8c5.6,3.2,3.4,12,2.3,16.2c-7.9,18.1-23.7,30.6-21.4,52.3 c0.4,3.4,1.2,6.6,2.4,9.7c3.2,8.2,9.1,15.6,16.9,22.1c2.2-0.1,4.5-0.2,6.7-0.3c0.5,0,1-0.1,1.5-0.1c-1.1-1.3-2.1-2.6-3.1-4 C352,147.9,348.3,136.3,348.5,124.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M380.6,154.3c2.1-14.2-1.1-29.3,2.7-43c0.5-1.7,1-3.4,1.8-5.1c4.3-10.5,12.4-17.5,21.2-23.1 c0.5-1.3,1.3-2.5,2.6-3.8c-27.6,8.9-36.8,31.3-40.4,53.9c-0.9,5.9-0.6,10.9,0,16.7c0.2,2.6,1.8,7.1,2.5,10.6 c2.8-0.1,5.6-0.3,8.5-0.4c0.2-0.7,0.3-1.3,0.5-2C380.2,156.9,380.4,155.6,380.6,154.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M408.5,126c-2.4-7.9-5.5-17.3-2.5-25.4c-3.5,3.7-4.2,8.3-4.5,12.9c-0.7,9.8,3.3,17.3,4.4,26.4 c0.9,7.5-1.2,14-3.5,20.6c1.9,0.2,3.7,0.5,5.5,0.9c1-2.2,1.7-4.6,2.3-6.4C413.3,144.9,411.5,135.6,408.5,126z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M444.6,128.4c-1.9-4-7.9-12-3.5-18.5c-1.3,0.1-2.5,0.4-3.5,0.9c-1.3,3.6-1.4,7.4-1,11.3 c0.1,1.5,0.3,3.1,0.6,4.6c1.2,8.7,1.5,17.9-0.1,26.6c-0.3,1.7-0.7,3.5-1.2,5.2c-1.4,4.5-3.7,9.9-7,14.1 c1.6,1.6,3.2,3.3,4.8,5.2c1.1,1.3,2.1,2.7,3,4.1C448.8,166.2,453,146,444.6,128.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M251.5,147.3c-3.2,16,4.6,33.9,19.8,42c1.2-1.9,2.6-3.7,4-5.4C258.2,174.1,253.1,160.2,251.5,147.3z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle5A);
export default __webpack_public_path__ + "static/media/man_hairstyle_5a.404f40314a48c5af37241f38f473c5c3.svg";
export { ForwardRef as ReactComponent };